import { createSelector } from 'reselect'

export const vesselLookupSelector = state => state.vesselLookup

export const selectedVesselSelector = createSelector(
  vesselLookupSelector,
  state => state.selectedItem
)
